export { default as CertificateTemplate } from './CertificateTemplate';
export { default as VaccinationCertificateTemplate } from './VaccinationCertificateTemplate';
export { default as PrescriptionTemplate } from './PrescriptionTemplate';
export { default as LabReportTemplate } from './LabReportTemplate';
export { default as DischargeSummaryTemplate } from './DischargeSummaryTemplate';
export { default as AmbulanceCertificateTemplate } from './AmbulanceCertificateTemplate';
export { default as ECCEmergencyCertificateTemplate } from './ECCEmergencyCertificateTemplate';
export { default as BloodDonationCertificateTemplate } from './BloodDonationCertificateTemplate';
export { default as InsuranceClaimPackTemplate } from './InsuranceClaimPackTemplate';
export { default as InvoiceReceiptTemplate } from './InvoiceReceiptTemplate';
export { default as ConsentFormTemplate } from './ConsentFormTemplate';
export { default as AppointmentReceiptTemplate } from './AppointmentReceiptTemplate';
export { default as PharmacyDocumentTemplate } from './PharmacyDocumentTemplate';
export { default as HospitalDocumentTemplate } from './HospitalDocumentTemplate';
export { default as AmbulanceInvoiceTemplate } from './AmbulanceInvoiceTemplate';
export { default as BloodBankDocumentTemplate } from './BloodBankDocumentTemplate';
export { default as InsuranceDocumentTemplate } from './InsuranceDocumentTemplate';
export { default as LabDocumentTemplate } from './LabDocumentTemplate';
export { default as PaymentReceiptTemplate } from './PaymentReceiptTemplate';

export const TEMPLATE_MAP: Record<string, string> = {
  // ─── A. Appointment / Booking ───
  APPOINTMENT_CONFIRMATION: 'AppointmentReceiptTemplate',
  CONSULTATION_RECEIPT: 'AppointmentReceiptTemplate',
  TELEMEDICINE_RECEIPT: 'AppointmentReceiptTemplate',
  APPOINTMENT_CANCELLATION: 'AppointmentReceiptTemplate',
  FOLLOWUP_SLIP: 'AppointmentReceiptTemplate',

  // ─── B. Lab ───
  LAB_BOOKING_RECEIPT: 'LabDocumentTemplate',
  LAB_SAMPLE_COLLECTION: 'LabDocumentTemplate',
  LAB_TEST_INVOICE: 'LabDocumentTemplate',
  LAB_REPORT_PDF: 'LabReportTemplate',
  LAB_REPORT_VERIFICATION: 'LabDocumentTemplate',
  HOME_SAMPLE_COLLECTION: 'LabDocumentTemplate',
  CRITICAL_LAB_ALERT: 'LabDocumentTemplate',

  // ─── C. Pharmacy ───
  PHARMACY_ORDER_INVOICE: 'PharmacyDocumentTemplate',
  PHARMACY_PAYMENT_RECEIPT: 'PharmacyDocumentTemplate',
  PRESCRIPTION_FULFILLMENT: 'PharmacyDocumentTemplate',
  MEDICINE_DELIVERY_RECEIPT: 'PharmacyDocumentTemplate',
  MEDICINE_RETURN_REFUND: 'PharmacyDocumentTemplate',
  MEDICINE_BATCH_EXPIRY: 'PharmacyDocumentTemplate',

  // ─── D. Hospital OPD/IPD/ER ───
  OPD_REGISTRATION: 'HospitalDocumentTemplate',
  OPD_INVOICE: 'HospitalDocumentTemplate',
  IPD_ADMISSION: 'HospitalDocumentTemplate',
  IPD_DAILY_BILL: 'HospitalDocumentTemplate',
  BED_WARD_INVOICE: 'HospitalDocumentTemplate',
  NURSING_INVOICE: 'HospitalDocumentTemplate',
  DOCTOR_VISIT_INVOICE: 'HospitalDocumentTemplate',
  OT_BOOKING: 'HospitalDocumentTemplate',
  OT_PROCEDURE_INVOICE: 'HospitalDocumentTemplate',
  SURGERY_CERTIFICATE: 'HospitalDocumentTemplate',
  ER_REGISTRATION: 'HospitalDocumentTemplate',
  ER_INVOICE: 'HospitalDocumentTemplate',
  HOSPITAL_DISCHARGE_SUMMARY: 'HospitalDocumentTemplate',
  FINAL_HOSPITAL_BILL: 'HospitalDocumentTemplate',
  DEPOSIT_RECEIPT: 'HospitalDocumentTemplate',
  HOSPITAL_REFUND_RECEIPT: 'HospitalDocumentTemplate',
  LAMA_DAMA_TRANSFER: 'HospitalDocumentTemplate',

  // ─── E. Ambulance/ECC ───
  AMBULANCE_BOOKING_RECEIPT: 'AmbulanceInvoiceTemplate',
  AMBULANCE_TRIP_INVOICE: 'AmbulanceInvoiceTemplate',
  AMBULANCE_TRANSPORT_CERTIFICATE: 'AmbulanceInvoiceTemplate',
  ECC_EVENT_CERTIFICATE: 'AmbulanceInvoiceTemplate',
  ER_HANDOVER: 'AmbulanceInvoiceTemplate',
  PARAMEDIC_NOTE: 'AmbulanceInvoiceTemplate',
  AMBULANCE_CANCELLATION: 'AmbulanceInvoiceTemplate',

  // ─── F. Insurance / NeoClaim ───
  INSURANCE_PRE_AUTH: 'InsuranceDocumentTemplate',
  INSURANCE_CLAIM_PACK: 'InsuranceDocumentTemplate',
  INSURANCE_CLAIM_RECEIPT: 'InsuranceDocumentTemplate',
  CLAIM_APPROVAL_LETTER: 'InsuranceDocumentTemplate',
  PATIENT_PAYABLE_ESTIMATE: 'InsuranceDocumentTemplate',
  INSURER_PAYABLE_ESTIMATE: 'InsuranceDocumentTemplate',
  HOSPITAL_ESTIMATE_INSURANCE: 'InsuranceDocumentTemplate',

  // ─── G. Blood Bank ───
  BLOOD_DONATION_CERT: 'BloodBankDocumentTemplate',
  BLOOD_REQUEST_RECEIPT: 'BloodBankDocumentTemplate',
  BLOOD_ISSUE_RECEIPT: 'BloodBankDocumentTemplate',
  BLOOD_TRACEABILITY: 'BloodBankDocumentTemplate',
  CROSSMATCH_REPORT: 'BloodBankDocumentTemplate',
  BLOOD_BANK_INVOICE: 'BloodBankDocumentTemplate',

  // ─── H. Vaccination / Certificates ───
  VACCINATION_CERTIFICATE: 'VaccinationCertificateTemplate',
  VACCINATION_RECEIPT: 'InvoiceReceiptTemplate',
  MEDICAL_FITNESS_CERTIFICATE: 'CertificateTemplate',
  SICK_LEAVE_CERTIFICATE: 'CertificateTemplate',
  INSTITUTION_CLEARANCE_CERTIFICATE: 'CertificateTemplate',
  HEALTH_CHECKUP_CERTIFICATE: 'CertificateTemplate',
  BIRTH_CERTIFICATE: 'CertificateTemplate',
  DEATH_CERTIFICATE: 'CertificateTemplate',
  DISABILITY_CERTIFICATE: 'CertificateTemplate',
  VACCINATION_COMPLETION_CERTIFICATE: 'VaccinationCertificateTemplate',
  CHRONIC_CARE_CERTIFICATE: 'CertificateTemplate',

  // ─── I. General Financial ───
  UNIFIED_PAYMENT_RECEIPT: 'PaymentReceiptTemplate',
  WALLET_TRANSACTION_RECEIPT: 'PaymentReceiptTemplate',
  REFUND_ACKNOWLEDGEMENT: 'PaymentReceiptTemplate',
  GST_TAX_INVOICE: 'PaymentReceiptTemplate',
  NHC_SERVICE_FEE: 'PaymentReceiptTemplate',

  // ─── Legacy mappings (existing certificate types) ───
  LAB_REPORT_CERTIFICATE: 'CertificateTemplate',
  PRESCRIPTION_CERTIFICATE: 'PrescriptionTemplate',
  DISCHARGE_SUMMARY_CERTIFICATE: 'DischargeSummaryTemplate',
  HOSPITAL_ADMISSION_CERTIFICATE: 'CertificateTemplate',
  SURGERY_PROCEDURE_CERTIFICATE: 'CertificateTemplate',
  INSURANCE_CLAIM_CERTIFICATE: 'InsuranceClaimPackTemplate',
  AMBULANCE_TRANSPORT_CERTIFICATE_LEGACY: 'AmbulanceCertificateTemplate',
  EMERGENCY_EVENT_CERTIFICATE: 'ECCEmergencyCertificateTemplate',
  BLOOD_DONATION_CERTIFICATE: 'BloodDonationCertificateTemplate',

  // ─── Health Vault document types ───
  LAB_REPORT: 'LabReportTemplate',
  PRESCRIPTION: 'PrescriptionTemplate',
  DISCHARGE_SUMMARY: 'DischargeSummaryTemplate',
  INVOICE: 'InvoiceReceiptTemplate',
  AMBULANCE_RECORD: 'AmbulanceCertificateTemplate',
  ECC_EMERGENCY_RECORD: 'ECCEmergencyCertificateTemplate',
  BLOOD_BANK_RECORD: 'BloodDonationCertificateTemplate',
  INSURANCE_DOCUMENT: 'InsuranceClaimPackTemplate',
  CLAIM_DOCUMENT: 'InsuranceClaimPackTemplate',
};
